// CliniQueue Patient App configuration
// USE_MOCK drives the live preview (no backend required).
// For production/downloadable build, set REACT_APP_USE_MOCK="false" and
// REACT_APP_API_BASE to your CliniQueue backend, e.g. https://api.cliniqueue.in/api

const rawApiBase = process.env.REACT_APP_API_BASE;
const defaultApiBase = "https://api.cliniqueue.in/api";
const normalizedApiBase = (rawApiBase || defaultApiBase).replace(/\/+$/, "");
export const API_BASE = normalizedApiBase;
export const API_ROOT = normalizedApiBase.endsWith("/api")
  ? normalizedApiBase.slice(0, -4)
  : normalizedApiBase;

export const USE_MOCK =
  (process.env.REACT_APP_USE_MOCK || "false").toLowerCase() !== "false";

export const BRAND = {
  name: "CliniQueue",
  tagline: "Connected care. Redefined.",
  logo:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_1e6af230-cb27-4a42-be7d-67615b999471/artifacts/s76yoc43_web_logo%20%282%29.webp",
};
